export default __webpack_public_path__ + "static/media/8.521ade1e.jpg";